import { createSlice } from '@reduxjs/toolkit';
import ls from 'localstorage-slim';

const initialState = {
  isFirstLoad: true,
  isWelcomeScreenHidden: false,
  isMenuOpen: false,
  isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),

  isIndexPage: false,
  isAreaOnePage: false,
  isAreaTwoPage: false,
  isDetailPage: false,

  indexMapTransform: { x: 0, y: 0 },
  areaMapTransform: { x: 0, y: 0 },
  areaTwoMapTransform: { x: 0, y: 0 }
};

initialState.isWelcomeScreenHidden = ls.get('makinomap-welcome-hidden');

export const globalSlice = createSlice({
  name: 'global',
  initialState: initialState,
  reducers: {
    setFirstLoad: (state, action) => {
      state.isFirstLoad = false;
    },

    setIndexMapTransform: (state, action) => {
      state.indexMapTransform = action.payload;
    },

    setAreaMapTransform: (state, action) => {
      state.areaMapTransform = action.payload;
    },

    setAreaTwoMapTransform: (state, action) => {
      state.areaTwoMapTransform = action.payload;
    },

    setIndexPage: (state, action) => {
      state.isIndexPage = action.payload;
    },

    setAreaOnePage: (state, action) => {
      state.isAreaOnePage = action.payload;
    },

    setAreaTwoPage: (state, action) => {
      state.isAreaTwoPage = action.payload;
    },

    setDetailPage: (state, action) => {
      state.isDetailPage = action.payload;
    },

    setMenuOpen: (state, action) => {
      state.isMenuOpen = action.payload;
    },

    setWelcomeScreenHidden: (state, action) => {
      state.isWelcomeScreenHidden = action.payload;
    }
  }
});

export const {
  setFirstLoad,
  setMenuOpen,
  setWelcomeScreenHidden,

  setIndexMapTransform,
  setAreaMapTransform,
  setAreaTwoMapTransform,

  setIndexPage,
  setAreaOnePage,
  setAreaTwoPage,
  setDetailPage
} = globalSlice.actions;

// Actions
export const updateIndexMapTransform = val => dispatch => {
  dispatch(setIndexMapTransform(val));
}

export const updateAreaMapTransform = val => dispatch => {
  dispatch(setAreaMapTransform(val));
}

export const updateAreaTwoMapTransform = val => dispatch => {
  dispatch(setAreaTwoMapTransform(val));
}

export const updateIndexPage = val => dispatch => {
  dispatch(setIndexPage(val));
}

export const updateAreaOnePage = val => dispatch => {
  dispatch(setAreaOnePage(val));
}

export const updateAreaTwoPage = val => dispatch => {
  dispatch(setAreaTwoPage(val));
}

export const updateDetailPage = val => dispatch => {
  dispatch(setDetailPage(val));
}

export const updateMenuOpen = val => dispatch => {
  document.body.classList.toggle('no-scroll', val);
  dispatch(setMenuOpen(val));
}

export const updateWelcomeScreen = val => dispatch => {
  const ONE_WEEK = 60 * 60 * 24 * 7;
  ls.set('makinomap-welcome-hidden', val, { ttl: ONE_WEEK });
  dispatch(setWelcomeScreenHidden(val));
}

export default globalSlice.reducer;
